<img [src]="image | base64: 'image/jpg'"/>
